import { Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Tooltip from '~/components/Tooltip';
import Toggle from '~/components/Toggle';
import { addListingDetailsType } from '~addListing/types';
import { PAYMENT_METHOD_INSTALLMENT_KEY } from '~addListing/utils/data';

const DownPaymentLabel = ({
  downPaymentTypeIsAmount,
  handleChangeValue,
  defaultDownPayment,
  defaultTotalInstallmentPrice,
  hasDownPayment,
  onToggleDownPayment,
}: {
  downPaymentTypeIsAmount: boolean;
  handleChangeValue: (value: number) => void;
  defaultDownPayment: number;
  defaultTotalInstallmentPrice: number;
  hasDownPayment: boolean;
  onToggleDownPayment: React.ChangeEventHandler<HTMLInputElement>;
}) => {
  const { t } = useTranslation('app');

  const { setValue } = useFormContext<addListingDetailsType>();
  const paymentMethod = useWatch({ name: 'paymentMethod' });

  const paymentMethodInstallment =
    paymentMethod === PAYMENT_METHOD_INSTALLMENT_KEY;

  return (
    <div className="flex justify-between">
      <p className="text-body-1 text-gray__dark_2 self-center flex items-center gap-x">
        {paymentMethodInstallment
          ? t('totalPaidAmounts')
          : t('isThereDownPayment')}
        {paymentMethodInstallment ? (
          <Tooltip
            text={t('totalPaidAmountsTooltip')}
            className="max-w-[272px]"
            id="down-payment-label-tooltip"
            children={
              <Icon name="info" size="16px" className="text-gray__dark_2" />
            }
          />
        ) : null}
        {!paymentMethodInstallment && (
          <Toggle open={hasDownPayment} onChange={onToggleDownPayment} />
        )}
      </p>
      {!paymentMethodInstallment && hasDownPayment && (
        <div className="flex flex-col gap-3">
          <div className="flex gap-3x">
            <button
              className={`w-[32px] ${
                downPaymentTypeIsAmount
                  ? 'text-gray__dark_1 text-body_2'
                  : 'text-blue text-link'
              }`}
              onClick={() => {
                setValue('downPaymentType', 'percentage');
                handleChangeValue(
                  Math.round(
                    (defaultDownPayment / defaultTotalInstallmentPrice) * 100,
                  ),
                );
              }}
            >
              {' '}
              %{' '}
            </button>
            <span className="w-[2px] bg-gray h-[24px]"></span>
            <button
              className={`w-[32px] ${
                downPaymentTypeIsAmount
                  ? 'text-blue text-link'
                  : 'text-gray__dark_1 text-body_2'
              }`}
              onClick={() => {
                setValue('downPaymentType', 'amount');
                handleChangeValue(defaultDownPayment);
              }}
            >
              EGP
            </button>
          </div>
          <div
            className={`w-full flex bg-gray rounded-[8px] ${downPaymentTypeIsAmount ? 'justify-end' : 'justify-start'}`}
          >
            <div className="bg-blue w-[32px] h-[2px] rounded-[8px]"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownPaymentLabel;
